import CaptchaService from '@root/core/src/services/captcha-service';
import ServerUtils from '@root/core/src/api/server-utils';

export async function getCurrentUserContext() {
  const { data } = await ServerUtils.authenticatedGet('/web_api/contexts/current_user', {
    expectedResponse: 200,
  });
  return data;
}

export async function emailNameSignup(params) {
  const { data } = await ServerUtils.unauthenticatedPost('/web_api/signup/with_name', {
    body: {
      signup: params,
    },
    expectedResponse: 201,
    expectedErrorResponses: [409, 422],
  });
  return data;
}

export async function withoutEmailSignup(params) {
  const { data } = await ServerUtils.unauthenticatedPost('/web_api/signup/without_email', {
    body: {
      signup: params,
    },
    expectedResponse: 201,
  });
  return data;
}

export async function emailLogin(loginParams, rootId) {
  const captchaToken = await CaptchaService.challenge('Email_Login');

  const { data } = await ServerUtils.unauthenticatedPost('/web_api/login', {
    body: {
      captchaToken,
      login: loginParams,
      rootId,
    },
    expectedResponse: 201,
    expectedErrorResponses: [401],
  });
  return data;
}

export async function associateUserToABTests(identifier) {
  const { data } = await ServerUtils.authenticatedPut('/web_api/ab_tests/associate_user', {
    expectedResponse: 204,
    body: {
      identifier,
    },
  });
  return data;
}
